import {h, render, Component} from 'preact';
import AddPaymentForm from '@components/account/Wallet/AddPaymentForm';
import {Query} from 'react-apollo';
import {client} from '@core/GraphQLProvider';
import {GetCustomer} from '@services/Customer/query.graphql';
import Spinner from '@components/common/Spinner';
import {getParameterByName} from '@util/URLUtils';
import Icon from '@components/common/Icon';
import ScrollToTop from '@components/common/ScrollToTop';

const ServiceError = () =>
    <div className="text-center">
        <h2 className="my-4 text-lg leading-tight">
            Sorry, we're experiencing a problem and are unable to load your payment options.
        </h2>
        <p className="mb-4 text-grey-dark">
            Please contact our Customer Support team to complete this order by calling
            {' '}
            <b className="text-grey-darker whitespace-no-wrap">{upi.conf.phoneTollFree}</b>
        </p>
    </div>;

const SuccessMessage = ( {cardDetails, showReturnMsg = false} ) =>
    <ScrollToTop>
        <div className="text-center">
            <h2 className="my-4 text-lg leading-tight flex items-center justify-center">
                <Icon.ui name="checkmark" className="text-xl mr-2 text-success"/>
                Payment details were saved!
            </h2>
            <p className="w-32 m-4 text-center inline-block">
                <i className={`icon-${cardDetails.issuer.toLowerCase()}`}></i>
            </p>
            <p className="m-4 text-grey-dark">
                A new {cardDetails.issuer} card ending in <b>{cardDetails.lastFour}</b> has been added
                to your account.
            </p>

            {showReturnMsg &&
            <div className="flex justify-center m-8">
                <Spinner message="Returning to MobileCRM"/>
            </div>
            }
        </div>
    </ScrollToTop>;

class AddCreditCard extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            cardDetails: null,
            showReturnMsg: false
        };
    }

    handlePaymentAdded = payload => {
        const callBackUrl = getParameterByName( 'callbackUrl' );
        if ( callBackUrl ) {
            const data = {
                action: 'newPaymentAdded',
                paymentId: payload.id
            };
            const encoded = btoa( JSON.stringify( data ) );

            setTimeout( () => {
                window.location = `${callBackUrl}${encoded}`;
            }, 3000 );
        }

        this.setState( {
            cardDetails: payload,
            showReturnMsg: Boolean( callBackUrl )
        } );
    };

    render() {
        const {cardDetails, showReturnMsg} = this.state;

        if ( cardDetails ) {
            return (
                <SuccessMessage cardDetails={cardDetails} showReturnMsg={showReturnMsg}/>
            );
        }

        return (
            <ScrollToTop>
                <AddPaymentForm
                    addressBook={this.props.addressBook}
                    onPaymentAdded={this.handlePaymentAdded}/>
            </ScrollToTop>
        );
    }
}

const CustomerQuery = ( props = {} ) => {
    let retryAttempts = 0;

    return ( {data, loading, error, refetch} ) => {
        if ( loading ) {
            return <Spinner className="justify-center" message="Loading customer info"/>
        }
        if ( error || !data || !data.customer ) {
            if ( retryAttempts < 2 ) {
                retryAttempts++;
                refetch();
                return <Spinner className="justify-center" message="Still loading customer info"/>;
            }
            return <ServiceError/>;
        }

        const {addresses} = data.customer;
        const addressBook = addresses.filter( addr => addr.addressType === 'Billing' );
        return <AddCreditCard addressBook={addressBook}/>;
    };
};

document.addEventListener( 'DOMContentLoaded', () => {
    const root = document.getElementById( 'account-add-payment-form' );
    if ( root ) {
        render(
            <Query client={client}
                   fetchPolicy="network-only"
                   query={GetCustomer}
                   variables={{
                       withWallet: true,
                       withAddresses: true
                   }}>
                {CustomerQuery( {} )}
            </Query>,
            root
        );
    }
} );
